import { Warning } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

type MissingFilterValueWarningProps = {
  isMissing: boolean;
  isRequired?: boolean;
};

export default function MissingFilterValueWarning({
  isMissing,
  isRequired = true,
}: MissingFilterValueWarningProps) {
  return isMissing ? (
    <Tooltip arrow title={`${isRequired ? 'Required' : 'Loaded'} value(s) missing`}>
      <Warning color={'error'} />
    </Tooltip>
  ) : (
    <></>
  );
}
